import gql from 'graphql-tag'

import { ChildFieldsFragment } from 'main/gql/child'
import { DesiredWeeklyScheduleFieldsFragment } from 'main/gql/desiredWeeklySchedule'
import { TourFieldsFragment } from 'main/gql/tour'
import { UserFieldsFragment } from 'main/gql/user'

export const SCHEDULE_MUTATION = gql`
  mutation ScheduleTour(
    $schoolId: ID!
    $tour: TourParams!
    $desiredWeeklySchedule: DesiredWeeklyScheduleParams!
    $user: UpdateUserParams!
  ) {
    scheduleTour(schoolId: $schoolId, tour: $tour) {
      ...TourFields
      children {
        ...ChildFields
      }
    }
    updateUser(user: $user) {
      ...UserFields
    }
    upsertDesiredWeeklySchedule(desiredWeeklySchedule: $desiredWeeklySchedule) {
      ...DesiredWeeklyScheduleFields
    }
  }

  ${ChildFieldsFragment}
  ${DesiredWeeklyScheduleFieldsFragment}
  ${TourFieldsFragment}
  ${UserFieldsFragment}
`
